var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    background-color: ".concat(theme.bgContent2(), ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 50px;\n    width: calc(250px - 1rem);\n  ");
});
var Title = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1rem;\n"], ["\n  font-size: 1rem;\n"])));
var Subtitle = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0.8rem;\n"], ["\n  font-size: 0.8rem;\n"])));
export var TaskCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (React.createElement(Card, null,
        React.createElement(Title, null, title),
        React.createElement(Subtitle, null, subtitle)));
};
var templateObject_1, templateObject_2, templateObject_3;
